export default "__VITE_ASSET__l0yQhIy4__"